import safeJsonStringify from 'safe-json-stringify';
const DEFAULT_STORAGE_KEY = 'evvntSubmissionForm';
const MAX_TIME_DIFF = parseInt(FORM_LOCALSTORAGE_TIMEOUT_SECONDS, 10) * 1000;

function loadCurrentData(key) {
  const currentValue = window.localStorage.getItem(key);
  return currentValue !== null ? JSON.parse(currentValue) : {};
}

export function preloadState(field, key = DEFAULT_STORAGE_KEY) {
  const jsonData = loadCurrentData(key);
  if (Object.keys(jsonData).length === 0) { return {}; }

  if ((Date.now() - jsonData.updatedAt) > MAX_TIME_DIFF) {
    clearState(key);
    return {};
  }
  return jsonData[field];
}

export function saveState(data = {}, key = DEFAULT_STORAGE_KEY) {
  const jsonData = loadCurrentData(key);
  const result = Object.assign({}, jsonData, data, { updatedAt: Date.now() });
  window.localStorage.setItem(key, safeJsonStringify(result));
}

export function clearState(key = DEFAULT_STORAGE_KEY) {
  window.localStorage.removeItem(key);
}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/lib/formStorage.js